<template lang="pug">
span
  template(v-if="member.profile_visible")
    a.ui.label(:href="member.link")
      | {{ contextName }}

  template(v-else)
    span.ui.label.disabled(v-tooltip="$t('group_member.no_details_tooltip')")
      | {{ contextName }}

</template>

<script lang="ts">
import Vue, { PropType } from "vue"
import { Client, GroupMember, Group, Level } from "suus-api"

type UserContext = {
  level?: Level | null
  client?: Client | null
  group?: Group | null
  client_id?: number | null
  level_id?: number | null
}

export default Vue.extend({
  name: "MemberLink",
  props: {
    member: { type: Object as PropType<GroupMember>, required: true },
    context: { type: Object as PropType<UserContext>, required: true },
  },
  computed: {
    contextClass(): "Level" | "Client" | null {
      return this.getContextClass(this.context)
    },
    contextName() {
      if (this.contextClass === "Level") return this.member.umbrella_name_short
      if (this.contextClass === "Client") return this.member.internal_name_short
      return this.member.umbrella_name_long
    },
  },
  methods: {
    getContextClass(context: UserContext): "Level" | "Client" | null {
      if (context.group)
        return this.getContextClass({
          level: context.group.level,
          client: context.group.client,
        })
      if (context.level || context.level_id) return "Level"
      if (context.client || context.client_id) return "Client"
      return null
    },
  },
})
</script>
